import CompaniesPage from './Companies'

const Companies = () => (
  <CompaniesPage/>
)

export default Companies
